export default __webpack_public_path__ + "f97b4151aa2c937500b3c6ef06ca1268.svg";